import styled, { css } from "styled-components";

export const LogoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 110px;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

export const SideBannerContainer = styled.div`
  width: 100%;
  max-width: 410px;
  height: 100%;
  background: #000FFF;
  padding-top: 49px;

  > a {
    @media (max-width: 768px) {
      display: flex;
    }
  }

  svg {
    color: white;
    margin-bottom: 88.69px;
    height: 36.31px;
    width: 173.42px;
    path,
    .a {
      color: white;
      fill: white !important;
    }
  }

  @media (max-width: 769px) {
    padding: 25px 22.21px 15px 25px;
    max-width: 100%;

    svg {
      margin-bottom: 0px;
    }
  }
`;

export const HeaderContainer = styled.header`
  display: none;
  flex-direction: column;
  color: white;
  margin-top: 20px;
  margin-bottom: 42px;

  span {
    color: white;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    svg {
      margin-left: -5px;
      margin-right: 4px;
      width: 20px;
      height: auto;
    }
  }

  h1 {
    color: white;
    font-size: 1.125rem;
    line-height: normal;
  }

  h2 {
    color: #c9dfff;
    font-size: 0.8125rem;
    line-height: normal;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const Header = styled.header`
  display: none;
  flex-direction: column;
  color: white;
  margin-bottom: 42px;

  span {
    color: white;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
  }

  h1 {
    color: white;
    font-size: 1.125rem;
    line-height: normal;
  }

  h2 {
    color: #c9dfff;
    font-size: 0.8125rem;
    line-height: normal;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
